// @flow
import React from 'react';
import SMConst from 'lib/SMConst';
import SMUSettingEditBaseFragment from './SMUSettingEditBaseFragment';
import sprintf from 'sprintf';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMGraphQLClient from 'lib/SMGraphQLClient';
import 'babel-polyfill';
import { companyFragment } from 'fragments';
import SMUBusinessAccountRemoveView from 'components/dashboard/users/settings/fragments/SMUBusinessAccountRemoveView';

type Props = {
  delegate: Object,
  user: Object,
  fragmentIndex: number,
  selectedFragment: number,
  errors: Object[],
};

type State = {
  user: Object,
  isCurrent: boolean,
  errors: [],
  listItems: [],
  showFormFlg: boolean,
  isOpenModal: boolean,
  companies: Object[],
  selectedCompany: Object,
}

class SMUSettingEditBusinessAccountFragmentView extends SMUSettingEditBaseFragment {

  constructor(props: Props) {
    super(props);

    this.state = {
      user: this.props.user,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
      showFormFlg: false,
      isOpenModal: false,
      companies: [],
      selectedCompany: {},
    };
  }

  componentDidMount() {
    if (this.isCurrent(this.props)) SMAppHelper.setTitle(I18n.t('dashboard.label_001200'));
    this.addSplitViewModal(this.refs.mainTable);

    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();

    ($(this.refs.form): any).startLoading();
    this.requestResource();
    ($(this.refs.form): any).stopLoading();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
    });
  }

  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }

  async requestResource(){
    const apiClient = new SMGraphQLClient();
    const query = `
      query {
        viewer {
          companies {
            results{
              ... on Company {
                ${companyFragment}
              }
            }
          }
        }
      }
    `;
    const obj = await apiClient.request(query);

    if (!obj) return false;
    if (obj.errors) {
      console.log(obj.errors);
      return false;
    }

    this.setState({
      companies: obj.data.viewer.companies.results
    });
  }

  async removeResource(){
    const apiClient = new SMGraphQLClient();
    const mutation = `
      mutation DisassociateCompanyUser($input: DisassociateCompanyUserInput!) {
        disassociateCompanyUser(input: $input) {
          disassociatedUserId
          company {
            id
          }
          userErrors {
            resource
            field
            message
          }
        }
      }`;
    const variables = `{
      "input":{
        "companyId": ${this.state.selectedCompany.id},
        "userId": ${this.state.user.id}
      }
    }`;
    await apiClient.request(mutation, variables);
  }

  async handleRemoveClick(e: Object) {
    e.preventDefault();

    ($(this.refs.form): any).startLoading();

    await this.removeResource();
    await this.requestResource();
    this.hideDialog();

    ($(this.refs.form): any).stopLoading();
  }

  handleModalChange(company: Object, e: Object) {
    this.setState({
      isOpenModal: !this.state.isOpenModal,
      selectedCompany: company
    });

    if (!this.state.isOpenModal) {
      this.showDialog(
        <SMUBusinessAccountRemoveView
          delegate={this}
          selectedCompany={company}
          isOpenModal={!this.state.isOpenModal}
        />
      );
    } else {
      this.hideDialog();
    }
  }

  renderBusinessAccounts() {
    let rows = [];

    this.state.companies.forEach((company)=>{
      rows.push(
        <div key={`company_${company.id}`} className="form-casette form-user-box">
          <img src={company.profileImage} alt={company.name} className="form-user-box__img" />
          <p className="form-user-box__name">{company.name}</p>
          <a onClick={this.handleModalChange.bind(this, company)} className="form-casette__close form-user-box__close"><i className="fa fa-close" /></a>
        </div>
      );
    });

    return rows;
  }

  render() {
    let errorRow = (this.state.errors) ? <p className="is-error mb10">{this.state.errors.message}</p> : "";
    return(
      <div style={this.fragmentStyle()} ref="mainTable">
        <form ref="form">
          <h2 className="dashboard-title mb20">
            ビジネスアカウント<br />
            <span className="dashboard-title__supplement">
              所属しているビジネスアカウントです。以下の会社に支払いを請求することができます。
            </span>
          </h2>
          {this.renderBusinessAccounts()}
        </form>
      </div>
    );
  }
}
export default SMUSettingEditBusinessAccountFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUSettingEditBusinessAccountFragmentView.jsx